import { render, staticRenderFns } from "./message-view-nav.vue?vue&type=template&id=4ec75984&scoped=true&"
import script from "./message-view-nav.vue?vue&type=script&lang=js&"
export * from "./message-view-nav.vue?vue&type=script&lang=js&"
import style0 from "./message-view-nav.vue?vue&type=style&index=0&id=4ec75984&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec75984",
  null
  
)

export default component.exports